import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { TransferRequestSummary } from '~/models/modules/transferRequest';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class TransferRequestsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    getTransferRequest(id: number) {
        return this.http.get<TransferRequestSummary>(this._url(`/${id}`));
    }

    getTransferRequests(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<TransferRequestSummary[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }

    createTransferRequest(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    updateTransferRequest(id: number, model: any) {
        return this.client.put(this._url(`/${id}`), model);
    }

    deleteTransferRequest(id: number) {
        return this.client.delete(this._url(`/${id}`));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/TransferRequests${v}`);
    }
}
